import React, { FC } from 'react';
import {Game, make_board, set_kifu, set_pieces, set_control_piece} from './game';
import {Setting} from "./setting";
import useReactRouter from 'use-react-router';
import { firebase_auth } from './config/firebase';
import Alert from './material/alert'

export const Room: FC = () => {
  const [enter_room_invalid, setEnterRoomInvalid] = React.useState(true);

  const handleEnterClose = () => {
    setEnterRoomInvalid(false);
  }

  // まだ初期局面からしか開始できないため、途中入室はできないようにする
  // TODO: 本来は画面を更新しても途中から再開できるべき

  // is_black, my_id, room_idをセット
  const {location} = useReactRouter();
  const paths = location.pathname.split("/");
  const room_id = paths[2];
  let is_black = true;
  let uid = "";
  const user = firebase_auth.currentUser;
  if(paths.length < 4){
    return(
      <Alert
        title={"部屋が存在しません。"}
        message={""}
        open={enter_room_invalid}
        handleClose={handleEnterClose}
      />
    );
  }
  if(paths[3] === "white"){
    is_black = false;
  }
  else if(paths[3] !== "black"){
    return(
      <Alert
        title={"部屋が存在しません。"}
        message={""}
        open={enter_room_invalid}
        handleClose={handleEnterClose}
      />
    );
  }

  if(!user){
    return(
      <Alert
        title={"読み込みに時間がかかっています。"}
        message={""}
        open={enter_room_invalid}
        handleClose={handleEnterClose}
      />
    );
  }
  uid = user.uid;
  const ua = navigator.userAgent.toLowerCase();
  const is_mobile = (ua.match(/Mobile/) !== null) || (ua.match(/mobile/) !== null);

  return(
    <Game
      start_pos={make_board()}
      start_black_piece={set_pieces()}
      start_white_piece={set_pieces()}
      current_pos={make_board()}
      current_black_piece={set_pieces()}
      current_white_piece={set_pieces()}
      control_piece={set_control_piece()}
      control_piece_sub={set_control_piece()}
      kifu={set_kifu()}
      turn={true}
      moves={-1}
      moves_sub={0}
      moves_max={0}
      clicked_piece={Setting.UNCLICKED}
      final_piece={Setting.UNCLICKED}
      my_name={""}
      your_name={""}
      is_black={is_black}
      is_black_sub={is_black}
      my_id={uid}
      your_id={""}
      room_id={room_id}
      inversion_total_num={0}
      inversion_num={0}
      inversion_turn={true}
      inversion_interval={0}
      inversion_moves={0}
      moved_piece={Setting.UNCLICKED}
      promotion={false}
      check={false}
      is_mobile={is_mobile}
    />
  );
}
